import { Box, Secondary, Text } from 'braid-design-system';

export const ProfileMenuHeading = ({ children }: { children: string }) => (
  <Box paddingRight="medium" paddingLeft="medium" paddingTop="small">
    <Text size="xsmall">
      <Secondary>{children.toUpperCase()}</Secondary>
    </Text>
  </Box>
);
